import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { useSelector } from "react-redux";

function getSelectedValue(value) {
  if (!value || Object.keys(value).length !== 3) return null;

  return { label: value.name, id: value.id, state: value.state };
}

function TripPort({ id, name, label, value, onChange }) {
  const validations = useSelector((state) => state.validation.validations);
  const getPorts = () => {
    let newPort = [];

    if (validations && validations.hasOwnProperty("port")) {
      validations.port.map((data) =>
        newPort.push({
          id: data.ID,
          label: `${data.ID} - ${data.NAME}, ${data.STATE}`,
          state: data.STATE,
        })
      );
      return newPort;
    }
  };
  const selectedValue = getSelectedValue(value);
  const styles = {
    maxWidth: window.innerWidth < 750 ? "100%" : "640px",
    minWidth: window.innerWidth < 750 ? "100%" : "460px",
  };
  // Added to avoid case sensitive issues with the search
  const filterOptions = createFilterOptions({
    ignoreCase: true,
  });

  return (
    <Autocomplete
      id={id}
      name={name}
      options={getPorts()}
      getOptionLabel={(option) => option.label}
      style={styles}
      onChange={onChange}
      value={selectedValue}
      isOptionEqualToValue={(option) => option.id}
      renderInput={(params) => (
        <TextField {...params} name={name} label={label} variant="standard" />
      )}
      filterOptions={filterOptions}
    />
  );
}

export default TripPort;
